import { render } from "./PronosticoFormLoggedIn.vue?vue&type=template&id=95146ee0&scoped=true"
import script from "./PronosticoFormLoggedIn.vue?vue&type=script&lang=js"
export * from "./PronosticoFormLoggedIn.vue?vue&type=script&lang=js"

import "./PronosticoFormLoggedIn.vue?vue&type=style&index=0&id=95146ee0&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95146ee0"]])

export default __exports__